import type { MeshTransform } from "./schema";
import { sanitizeTransform } from "./transformMath";

type PreviewState = {
  enabled: boolean;
  transformsByMeshUuid: Record<string, MeshTransform>;
};

const state: PreviewState = {
  enabled: false,
  transformsByMeshUuid: {},
};

const EVENT_NAME = "mesh-editor-preview-updated";

export function setPreviewEnabled(enabled: boolean): void {
  state.enabled = !!enabled;
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function setPreviewTransformsByMeshUuid(
  transformsByMeshUuid: Record<string, MeshTransform>
): void {
  const next: Record<string, MeshTransform> = {};
  Object.entries(transformsByMeshUuid || {}).forEach(([meshUuid, transform]) => {
    next[meshUuid] = sanitizeTransform(transform);
  });
  state.transformsByMeshUuid = next;
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function clearPreviewState(): void {
  state.enabled = false;
  state.transformsByMeshUuid = {};
  window.dispatchEvent(new CustomEvent(EVENT_NAME));
}

export function getPreviewTransformForMeshUuid(meshUuid?: string): MeshTransform | null {
  if (!meshUuid || !state.enabled) return null;
  return state.transformsByMeshUuid[meshUuid] || null;
}

export function getPreviewUpdateEventName(): string {
  return EVENT_NAME;
}
